export default __webpack_public_path__ + "static/media/healthcare-mobile.209a62e4.jpg";